import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics tracking function
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Track page views
export const trackPageView = (page_path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-64KE66VJXF', {
      page_path: page_path
    });
  }
};

// Analytics component to track page views
export const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null; // This component doesn't render anything
};

// Custom hooks for tracking specific events
export const useAnalytics = () => {
  const trackToolUsage = (toolName) => {
    trackEvent('tool_used', 'engagement', toolName);
  };

  const trackTextAnalysis = (toolName, textLength) => {
    trackEvent('text_analyzed', 'engagement', toolName, textLength);
  };

  const trackCopyAction = (toolName) => {
    trackEvent('copy_action', 'engagement', toolName);
  };

  const trackFeedback = (toolName, feedbackType) => {
    trackEvent('feedback_submitted', 'engagement', `${toolName}_${feedbackType}`);
  };

  const trackSubscription = (email) => {
    trackEvent('newsletter_signup', 'conversion', 'email_signup');
  };

  return {
    trackToolUsage,
    trackTextAnalysis,
    trackCopyAction,
    trackFeedback,
    trackSubscription
  };
}; 